import { render, staticRenderFns } from "./meus_pets.vue?vue&type=template&id=1370ef13&scoped=true"
import script from "./meus_pets.vue?vue&type=script&lang=js"
export * from "./meus_pets.vue?vue&type=script&lang=js"
import style0 from "./meus_pets.vue?vue&type=style&index=0&id=1370ef13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370ef13",
  null
  
)

export default component.exports